import * as React from 'react';
import {
    Card, DatePeriodColumn, SimpleTable, StatusColumn, WarningModal,
} from 'components';
import EditFileIcon from 'components/assets/svg/edit_file.svg';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { connect } from 'react-redux';
import { useLoading } from 'hooks';
import { HEADER } from './TableHeader';
import { Color, ColorStatus } from '_helpers';
import { PaginationImpl } from 'components/defaultValues';
import { ExamDetailsContainer } from '../ExamDetailsContainer';

const ConductRequestsListContainer: React.FC<IProps> = (props) => {
    const [selectedId, selectId] = React.useState<React.ReactText | null>(null);
    const [loading, fetchExams] = useLoading(props.fetchWaitingForApprovalExams);

    React.useEffect(() => {
        fetchExams();
    }, []);

    const rows = React.useMemo(() => {
        if (!props.waitingForApprovalExams) return [];
        return props.waitingForApprovalExams.items.map(i => ({
            id: i.id,
            columns: [
              <DatePeriodColumn dateFrom={i.date} dateTo={i.lastDate} />,
              i.qualificationTitle,
              <StatusColumn status={new ColorStatus(Color.Orange, 'Одобрить проведение')} />,
            ],
        }));
    }, [props.waitingForApprovalExams]);

    return (
      <Card
        withoutPadding
        showLoader={loading && !props.waitingForApprovalExams}
        title="Запросы на проведение"
        category="Список всех запросов от секретаря АПК на проведение аккредитационных мероприятий"
      >
          <SimpleTable
            placeholderTitle="Нет запросов на проведение"
            placeholderText="Здесь будут отображаться все запросы на проведение аккредитационных мероприятий"
            placeholderIcon={EditFileIcon}
            tableRows={rows}
            tableHeaders={HEADER}
            handleRowClick={selectId}
            pagination={new PaginationImpl(props.waitingForApprovalExams).getPaginationData()}
            onPagination={p => props.fetchWaitingForApprovalExams({ page: p.page, pageSize: p.perPage })}
          />

          <WarningModal
            withoutCancelButton
            large
            card
            title={props.examDetails ? props.examDetails.qualificationTitle : ''}
            show={!!selectedId}
            onHide={() => {
                selectId(null);
                props.fetchWaitingForApprovalExams({});
            }}
          >
              {selectedId && (
                <ExamDetailsContainer
                  examId={String(selectedId)}
                />
              )}
          </WarningModal>
      </Card>
    );
};

const mapStateToProps = (state: IRootState) => ({
    waitingForApprovalExams: state.exams.waitingForApprovalExams,
    examDetails: state.exams.examDetails,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchWaitingForApprovalExams: dispatch.exams.fetchWaitingForApprovalExams,
    clearWaitingForApprovalExams: () => dispatch.exams.setWaitingForApprovalExams(null),
});

type ConnectedProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
type IProps = ConnectedProps;

export default connect(mapStateToProps, mapDispatchToProps)(ConductRequestsListContainer);
